module.exports = __webpack_public_path__ + "img/Deauthorize-Zoom.d9066d5a.png";